import React from 'react';
import { useNavigate } from 'react-router-dom';

import {
  ICON_CATEGORY_SEARCH_ACTIVE,
  ICON_CHECK_COMPELETE,
  ICON_NAVIGATE_BACK,
  ICON_SETTLEMENT_CHECK,
  ICON_TERM_CHECKED_ABLE,
} from 'assets/icons';
import CommonImage from 'components/common/CommonImage';
import Row from 'components/common/Row';
import Text from 'components/common/Text';
import Column from 'components/common/Column';
import BasicButton from 'components/Button/BasicButton';
import { HEADER_HEIGHT } from 'constants/style';

interface SettlementListHeaderIProps {
  isMobile: boolean;
  isShowRequireInvoice: boolean;
  handleIsOpenSearchModal: () => void;
  handleShowRequireInvoice: () => void;
}

const SettlementListHeader: React.FC<SettlementListHeaderIProps> = props => {
  const {
    isMobile,
    isShowRequireInvoice,
    handleIsOpenSearchModal,
    handleShowRequireInvoice,
  } = props;

  const navigate = useNavigate();

  const renderContent = (): JSX.Element => {
    return (
      <React.Fragment>
        <Row gap="16px">
          <CommonImage
            src={ICON_NAVIGATE_BACK}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Text color="#1b1c1e" size="24px" style={{ lineHeight: '36px' }}>
            전체보기
          </Text>
        </Row>
        <Row gap="12px">
          <BasicButton
            content={
              <Row gap="4px">
                <CommonImage
                  // src={
                  //   isAcceptFilter
                  //     ? ICON_CATEGORY_SEARCH_ACTIVE
                  //     : ICON_CATEGORY_SEARCH
                  // }
                  src={ICON_CATEGORY_SEARCH_ACTIVE}
                  onClick={handleIsOpenSearchModal}
                  style={{ width: '20px', height: '20px' }}
                />
                <Text color="#1b1c1e">검색</Text>
                {/* <Text color="#1b1c1e">{isAcceptFilter ? '검색 적용' : '검색'}</Text> */}
              </Row>
            }
            onClick={handleIsOpenSearchModal}
            // style={{
            //   height: '40px',
            //   border: isAcceptFilter ? '1.5px solid #1b1c1e' : '1px solid #dbdcdf',
            //   background: isAcceptFilter ? '#f4f4f5' : '#fff',
            // }}
          />
          <BasicButton
            content={
              <Row gap="4px">
                <CommonImage
                  // src={
                  //   isAcceptFilter
                  //     ? ICON_CATEGORY_SEARCH_ACTIVE
                  //     : ICON_CATEGORY_SEARCH
                  // }
                  src={
                    isShowRequireInvoice
                      ? ICON_TERM_CHECKED_ABLE
                      : ICON_SETTLEMENT_CHECK
                  }
                  onClick={handleShowRequireInvoice}
                  style={{ width: '20px', height: '20px' }}
                />
                <Text color="#1b1c1e">미지급 정산서만 보기</Text>
                {/* <Text color="#1b1c1e">{isAcceptFilter ? '검색 적용' : '검색'}</Text> */}
              </Row>
            }
            onClick={handleShowRequireInvoice}
            style={{
              border: isShowRequireInvoice
                ? '1.5px solid #1b1c1e'
                : '1px solid #dbdcdf',
              background: isShowRequireInvoice ? '#F7F7F8' : '#fff',
            }}
          />
        </Row>
      </React.Fragment>
    );
  };

  const renderContents = (): JSX.Element => {
    if (isMobile) {
      return (
        <Column
          gap="24px"
          align="flex-start"
          style={{
            position: 'sticky',
            top: 0,
            padding: '32px 0',
            background: '#fff',
          }}
        >
          {renderContent()}
        </Column>
      );
    }

    return (
      <Row
        justifyContent="space-between"
        style={{
          position: 'sticky',
          top: `${HEADER_HEIGHT}px`,
          padding: '32px 0',
          width: '100%',
          background: '#fff',
        }}
      >
        {renderContent()}
      </Row>
    );
  };

  return renderContents();
};

export default SettlementListHeader;
